<template>
  <div class="index" :class="[ getTerminalForChrome() ? 'index-mo': 'index-pc']">
    <SwiperCom class="siwper"></SwiperCom>
    <div class="sign-layout">
      <!--<div class="content">
        <div class="sign-l">
          <div class="l-t">
            <div class="text">{{newsInfo.firstTitle}}</div>
            <div class="button">
              <a :href="newsInfo.firstUrl" target="_self">了解报名详情</a>
            </div>
          </div>
          <div class="image" @click="toUrl(newsInfo.firstUrl)">
            &lt;!&ndash; <img src="../../assets/stu1.png" alt /> &ndash;&gt;
            <img src="../../assets/newStu1.png" alt />
          </div>
          &lt;!&ndash; <div class="ra">
            <img src="../../assets/ra.png" alt />
          </div> &ndash;&gt;
        </div>
        <div class="sign-r">
          <div
            v-if="getTerminalForChrome()"
            style="display: flex;align-items: center;flex-direction: column"
          >
            <div class="text">{{newsInfo.secondTitle}}</div>
            <div class="button">
              &lt;!&ndash; <a :href="newsInfo.secondUrl" target="_blank">了解报名详情</a> &ndash;&gt;
              <a :href="newsInfo.secondUrl" target="_self">了解报名详情</a>
            </div>
          </div>
          <div class="image" @click="toUrl(newsInfo.secondUrl)">
            &lt;!&ndash; <img src="../../assets/stu2.png" /> &ndash;&gt;
            <img src="../../assets/newStu2.png" />
          </div>
          <div v-if="!getTerminalForChrome()">
            <div class="text">{{newsInfo.secondTitle}}</div>
            <div class="button">
              &lt;!&ndash; <a :href="newsInfo.secondUrl" target="_blank">了解报名详情</a> &ndash;&gt;
              <a :href="newsInfo.secondUrl" target="_self">了解报名详情</a>
            </div>
          </div>
          &lt;!&ndash; <div class="ra">
            <img src="../../assets/ra.png" alt />
          </div> &ndash;&gt;
        </div>
      </div>-->


      <div class="content" style="align-items: center !important;">
        <div class="sign-l">
          <div class="image" @click="toUrl(newsInfo.firstUrl)">
            <img src="../../assets/newStu1.png" alt />
          </div>
        </div>
        <div class="sign-r">
          <div
            v-if="getTerminalForChrome()"
            style="display: flex;align-items: center;flex-direction: column"
          >
            <div class="text">{{newsInfo.firstTitle}}</div>
            <div class="button">
              <a :href="newsInfo.firstUrl" target="_self">了解报名详情</a>
            </div>
          </div>
          <div v-if="!getTerminalForChrome()">
            <div class="text">{{newsInfo.firstTitle}}</div>
            <div class="button"  style="margin-left: 112px">
              <a :href="newsInfo.firstUrl" target="_self">了解报名详情</a>
            </div>
          </div>
        </div>
      </div>

      <div class="content" style="align-items: center !important;">
        <div class="sign-l">
          <div class="image" @click="toUrl(newsInfo.secondUrl)">
            <img src="../../assets/newStu2.png" alt />
          </div>
        </div>
        <div class="sign-r">
          <div
            v-if="getTerminalForChrome()"
            style="display: flex;align-items: center;flex-direction: column"
          >
            <div class="text">{{newsInfo.secondTitle}}</div>
            <div class="button">
              <a :href="newsInfo.secondUrl" target="_self">了解报名详情</a>
            </div>
          </div>
          <div v-if="!getTerminalForChrome()">
            <div class="text">{{newsInfo.secondTitle}}</div>
            <div class="button"  style="margin-left: 112px">
              <a :href="newsInfo.secondUrl" target="_self">了解报名详情</a>
            </div>
          </div>
        </div>
      </div>

      <div class="content" style="align-items: center !important;">
        <div class="sign-l">
          <div class="image" @click="toUrl(newsInfo.fourthUrl)">
            <img src="../../assets/newStu4.png" alt />
          </div>
        </div>
        <div class="sign-r">
          <div
            v-if="getTerminalForChrome()"
            style="display: flex;align-items: center;flex-direction: column"
          >
            <div class="text">{{newsInfo.fourthTitle}}</div>
            <div class="button">
              <a :href="newsInfo.fourthUrl" target="_self">了解报名详情</a>
            </div>
          </div>
          <div v-if="!getTerminalForChrome()">
            <div class="text">{{newsInfo.fourthTitle}}</div>
            <div class="button"  style="margin-left: 112px">
              <a :href="newsInfo.fourthUrl" target="_self">了解报名详情</a>
            </div>
          </div>
        </div>
      </div>
      <div class="contact">
        <img src="../../assets/lianxi.png" alt="" @click="toContact">
        <!-- <span class="text">想了解更多</span>
        <span class="text col-g">
          <a :href="newsInfo.thirdUrl" target="_self">{{newsInfo.thirdTitle}} >>></a>
        </span> -->
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCom from './components/SwiperCom';
import { mapGetters } from 'vuex';
import { getNewsInfo } from '@/api/school';
export default {
  components: {
    SwiperCom
  },
  data() {
    return {
      newsInfo: {
        firstTitle: '',
        firstUrl: '',
        secondTitle: '',
        secondUrl: '',
        thirdTitle: '',
        thirdUrl: '',
        fourthTitle: '',
        fourthUrl: ''
      }
    };
  },
  methods: {
    ...mapGetters(['getTerminalForChrome']),
    toContact() {
      const a = document.createElement('a')
      a.href = this.newsInfo.thirdUrl
      a.target = '_self'
      a.click()
      a = null
    },
    toUrl(url) {
      let a = document.createElement('a')
      a.href = url
      a.target = '_self'
      a.click()
      a = null
    },
    _getNewsInfo() {
      getNewsInfo().then(res => {
        if (res.status === 200) {
          const { data } = res.data;
          // // console.log('data', dta)
          const obj = {
            firstTitle: data[0]['learnmoretitle'],
            firstUrl: data[0]['turnurl'],
            secondTitle: data[1]['learnmoretitle'],
            secondUrl: data[1]['turnurl'],
            thirdTitle: data[2]['learnmoretitle'],
            thirdUrl: data[2]['turnurl'],
            fourthTitle: data[3]['learnmoretitle'],
            fourthUrl: data[3]['turnurl']
          };
          this.newsInfo = { ...obj };
        }
      });
    }
  },
  mounted() {
    this._getNewsInfo();
  }
};
</script>

<style lang="scss" scoped>
.index-pc {
  align-items: center !important;
  .siwper {
    // height: 1080px;
  }
  .sign-layout {
    width: 100%;
    display: flex;
    align-items: center !important;
    flex-direction: column;
    justify-content: center;
    .content {
      width: 1280px;
      display: flex;
      padding-top: 48px;
      .text {
        font-size: 48px;
        color: #333333;
        margin-bottom: 48px;
      }
      .button {
        width: 280px;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: linear-gradient(180deg, #2f75e1 0%, #45d0b0 100%);
        border-radius: 34.5px;
        font-size: 20px;
        color: #ffffff;
        cursor: pointer;
      }
      .sign-l {
        margin-right: 100px;
        position: relative;
        .image {
          width: 573px;
          height: 438px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            cursor: pointer;
            transition: all 0.6s;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
        .ra {
          position: absolute;
          width: 65px;
          height: 98px;
          left: 0px;
          top: 38%;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .l-t {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 105px;
        }
      }
      .sign-r {
        position: relative;
        .image {
          width: 539px;
          height: 422px;
          margin-left: 50px;
          margin-bottom: 88px;
          margin-top: 40px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            cursor: pointer;
            transition: all 0.6s;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
        .ra {
          position: absolute;
          width: 65px;
          height: 98px;
          right: 0px;
          top: 0px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
    .contact {
      margin-top: 120px;
      margin-bottom: 96px;
      img {
        vertical-align: middle;
        cursor: pointer;
        transition: transform .3s;
        &:hover {
          transform: scale(1.1);
        }
      }
      .text {
        font-size: 35px;
        color: #333333;
      }
      .col-g {
        display: inline-block;
        // width: 296px;
        border-bottom: 3px solid #31a087;
        margin-left: 16px;
        cursor: pointer;
        transition: transform .3s;
        &:hover {
          transform: scale(1.1);
        }
        a {
          color: #31a087;
        }
      }
    }
  }
  a {
    text-decoration: none;
    color: #ffffff;
  }
}
.index-mo {
  .siwper {
    // height: 50vh;
  }
  .sign-layout {
    .content {
      .sign-l {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 8.53vw;
        position: relative;
        .image {
          width: 86.27vw;
          height: 65.87vw;
          margin-top: 10.27vw;
          img {
            width: 100%;
          }
        }
        .ra {
          position: absolute;
          top: 40%;
          left: 5%;
        }
      }
      .sign-r {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .image {
          width: 86.27vw;
          height: 67.6vw;
          margin-top: 10.27vw;
          img {
            width: 100%;
          }
        }
        .ra {
          position: absolute;
          right: 8%;
          top: 38%;
        }
      }
      .ra {
        width: 8.67vw;
        height: 13.07vw;
        img {
          width: 100%;
        }
      }
      .text {
        font-size: 6.4vw;
        color: #333333;
        margin-bottom: 6.4vw;
      }
      .button {
        width: 37.33vw;
        height: 7.47vw;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 34.5px;
        background-image: linear-gradient(180deg, #2f75e1 0%, #45d0b0 100%);
        a {
          font-size: 2.67vw;
          color: #ffffff;
        }
      }
    }
    .contact {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 9.2vw 0vw;
      img {
        width: 50vw;
        vertical-align: middle;
      }
      span:first-child {
        font-size: 4.8vw;
        color: #333333;
      }
      span:last-child {
        border-bottom: 0.4vw solid #31a087;
        a {
          font-size: 5.33vw;
          color: #31a087;
        }
      }
    }
  }
}
</style>
